module.exports = __webpack_public_path__ + "static/media/IMG-5.994141f7.jpg";